import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Wordmark from "./Wordmark";

export default function Nav() {
  const { authenticated, role, logout } = useAuth();
  const loc = useLocation();
  const onLanding = loc.pathname === "/";

  return (
    <nav
      className="sticky top-0 z-50 border-b backdrop-blur-xl"
      style={{
        background: "rgba(253, 251, 247, 0.9)",
        borderColor: "rgba(229, 225, 213, 0.6)",
      }}
      data-testid="main-nav"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="https://www.managemeantexcellence.com"
          target="_blank"
          rel="noopener"
          data-testid="nav-logo"
          className="flex items-center"
          title="Visit Manage(Meant) Excellence"
        >
          <Wordmark variant="color" size="sm" />
        </a>
        <div className="flex items-center gap-3 md:gap-7 text-sm">
          {onLanding && (
            <>
              <a href="#scenarios" className="hidden md:inline text-prose hover:text-[color:var(--mme-teal)] transition-colors" data-testid="nav-scenarios">
                Scenarios
              </a>
              <a href="#how" className="hidden md:inline text-prose hover:text-[color:var(--mme-teal)] transition-colors" data-testid="nav-how">
                How it works
              </a>
              <a href="#faq" className="hidden md:inline text-prose hover:text-[color:var(--mme-teal)] transition-colors" data-testid="nav-faq">
                FAQ
              </a>
              <a href="#pricing" className="btn-primary !py-2.5 !px-5 !text-xs hidden md:inline-flex" data-testid="nav-cta">
                Get the kit
              </a>
            </>
          )}
          {authenticated ? (
            <>
              {role === "buyer" && (
                <Link
                  to="/library"
                  className="btn-primary !py-2.5 !px-5 !text-xs inline-flex"
                  data-testid="nav-open-toolkit"
                >
                  Open my toolkit
                </Link>
              )}
              {role === "admin" && (
                <>
                  <Link to="/library" className="text-prose hover:text-[color:var(--mme-teal)]" data-testid="nav-library">
                    Library
                  </Link>
                  <Link to="/admin" className="text-prose hover:text-[color:var(--mme-teal)]" data-testid="nav-admin">
                    Admin
                  </Link>
                </>
              )}
              <button onClick={logout} className="text-prose hover:text-[color:var(--mme-teal)]" data-testid="nav-logout">
                Sign out
              </button>
            </>
          ) : (
            <Link to="/access" className="text-prose hover:text-[color:var(--mme-teal)]" data-testid="nav-access">
              I already bought
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

